<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CardsListItemArticleLot',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({ ref: 'referentiel/referentiel' })
  },
  methods: {
    getPresentationArticleLibelle (code) {
      for (const presentation of this.ref.presentationsArticles) {
        if (presentation.code === code) {
          return presentation.libelle;
        }
      }
    }
  }
};
</script>
<template>
  <!-- :class="{ 'grey lighten-4': item.tranche.complete, 'mb-6':isMobile && item.quantiteCommandee > 0}" -->
  <div
    class="list-item"
    :class="{ 'mb-6':isMobile && item.quantiteCommandee > 0}"
  >
    <div>
      <strong>{{ item.libelle }}</strong><sub class="num-article">{{ item.numArticle }}</sub>
      <div>{{ getPresentationArticleLibelle(item.codePresentation) }}</div>
      <div>{{ item.tranche.quantite | formatDecimal(0,3) }} kg/animal</div>
      <div
        v-if="item.quantiteCommandee > 0"
        class="mb-3"
      />
      <v-chip
        v-if="item.quantiteCommandee > 0"
        class="chip-qte white--text"
        color="#888"
      >
        <span class="mr-2">Déjà commandé :</span><strong>{{ item.quantiteCommandee | formatDecimal(0,3) }} t</strong>
      </v-chip>
    </div>
    <div class="actions-container">
      <slot
        name="actions"
        :item="item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-item {
  display: flex;
  // flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 1em;
  height: 100%;
  & > *:first-child {
    flex-grow: 1;
  }
  & > *:not(:first-child) {
    margin-left: 1em;
  }
}

.chip-qte {
  display: block;
  position: absolute;
  left: 20px;
  bottom: -15px;
}
</style>
